module.exports = __webpack_public_path__ + "media/images/social/twitter-square-brands-334492d722a3ef5873ac746f8f11f158.svg";